import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CarouselBanner from './common/CarouselBanner';
import './MedicinalGarden.css';

// 导入所有植物图片
const plantImages = [];
for (let i = 1; i <= 25; i++) {
  const num = String(i).padStart(2, '0');
  plantImages.push(require(`../assets/zwzly/zwzly_${num}.png`));
}

// 植物数据配置
const plantCategories = [
  {
    id: 'rare',
    name: '珍稀濒危药用植物',
    description: '国家重点保护的珍稀濒危药用植物，具有极高的药用和科研价值',
    plants: [
      { name: '铁皮石斛', latin: 'Dendrobium officinale', usage: '滋阴清热，益胃生津', image: plantImages[0] },
      { name: '金线莲', latin: 'Anoectochilus roxburghii', usage: '清热凉血，除湿解毒', image: plantImages[1] },
      { name: '重楼', latin: 'Paris polyphylla', usage: '清热解毒，消肿止痛', image: plantImages[2] },
      { name: '天麻', latin: 'Gastrodia elata', usage: '平肝息风，祛风通络', image: plantImages[3] },
      { name: '七叶一枝花', latin: 'Paris polyphylla var. chinensis', usage: '清热解毒，消肿止痛', image: plantImages[4] }
    ]
  },
  {
    id: 'mountain',
    name: '高山特色药材',
    description: '生长在海拔1000米以上的高山药材，适应高寒气候，药效独特',
    plants: [
      { name: '党参', latin: 'Codonopsis pilosula', usage: '补中益气，健脾益肺', image: plantImages[5] },
      { name: '黄芪', latin: 'Astragalus membranaceus', usage: '补气固表，利尿消肿', image: plantImages[6] },
      { name: '当归', latin: 'Angelica sinensis', usage: '补血活血，调经止痛', image: plantImages[7] },
      { name: '川贝母', latin: 'Fritillaria cirrhosa', usage: '清热润肺，化痰止咳', image: plantImages[8] },
      { name: '雪莲花', latin: 'Saussurea involucrata', usage: '温肾壮阳，调经止血', image: plantImages[9] }
    ]
  },
  {
    id: 'common',
    name: '常用中药材',
    description: '临床应用广泛的传统中药材，疗效确切，使用历史悠久',
    plants: [
      { name: '金银花', latin: 'Lonicera japonica', usage: '清热解毒，疏散风热', image: plantImages[10] },
      { name: '连翘', latin: 'Forsythia suspensa', usage: '清热解毒，消肿散结', image: plantImages[11] },
      { name: '板蓝根', latin: 'Isatis indigotica', usage: '清热解毒，凉血利咽', image: plantImages[12] },
      { name: '黄芩', latin: 'Scutellaria baicalensis', usage: '清热燥湿，泻火解毒', image: plantImages[13] },
      { name: '柴胡', latin: 'Bupleurum chinense', usage: '疏肝解郁，退热升阳', image: plantImages[14] }
    ]
  },
  {
    id: 'aromatic',
    name: '芳香药用植物',
    description: '含有挥发油的芳香植物，具有理气、开窍、驱虫等功效',
    plants: [
      { name: '薄荷', latin: 'Mentha haplocalyx', usage: '疏风散热，清头目', image: plantImages[15] },
      { name: '紫苏', latin: 'Perilla frutescens', usage: '解表散寒，行气和胃', image: plantImages[16] },
      { name: '藿香', latin: 'Pogostemon cablin', usage: '芳香化湿，和中止呕', image: plantImages[17] },
      { name: '艾叶', latin: 'Artemisia argyi', usage: '温经止血，散寒止痛', image: plantImages[18] },
      { name: '香附', latin: 'Cyperus rotundus', usage: '疏肝理气，调经止痛', image: plantImages[19] }
    ]
  },
  {
    id: 'tonic',
    name: '补益类药材',
    description: '具有补益人体气血阴阳的药材，用于虚损病症的治疗',
    plants: [
      { name: '人参', latin: 'Panax ginseng', usage: '大补元气，复脉固脱', image: plantImages[20] },
      { name: '西洋参', latin: 'Panax quinquefolius', usage: '补气养阴，清热生津', image: plantImages[21] },
      { name: '枸杞子', latin: 'Lycium barbarum', usage: '滋补肝肾，明目润肺', image: plantImages[22] },
      { name: '何首乌', latin: 'Polygonum multiflorum', usage: '补益精血，乌须发', image: plantImages[23] },
      { name: '肉苁蓉', latin: 'Cistanche deserticola', usage: '补肾阳，益精血', image: plantImages[24] }
    ]
  }
];

function MedicinalGarden() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedPlant, setSelectedPlant] = useState(null);
  const [carouselIndexes, setCarouselIndexes] = useState({});

  // 初始化每个分类的轮播索引
  useEffect(() => {
    const indexes = {};
    plantCategories.forEach(cat => {
      indexes[cat.id] = 0;
    });
    setCarouselIndexes(indexes);
  }, []);

  // 自动轮播
  useEffect(() => {
    const interval = setInterval(() => {
      setCarouselIndexes(prev => {
        const newIndexes = { ...prev };
        plantCategories.forEach(cat => {
          newIndexes[cat.id] = (prev[cat.id] + 1) % cat.plants.length;
        });
        return newIndexes;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="medicinal-garden-page">
      {/* 使用CarouselBanner组件 */}
      <CarouselBanner 
        categoryNameEn="MedicinalGarden"
        defaultImage={require('../assets/xlhy/z2.png')}
        className="medicinal-garden-banner"
      />

      {/* 主要内容区域 */}
      <div className="page-container">
        {/* 介绍部分 */}
        <section className="intro-section">
          <h2>园区概览</h2>
          <p className="intro-text">
            依托庐山山地生态环境，在海拔1000-1300米的高郊口山谷中，专设药园展示山地药用植物。
            目前已收集药用植物300余种，涵盖草本、灌木、藤本及珍稀濒危物种。
            药园不仅是植物资源库，更是中医药文化与生态保护的活态课堂。
          </p>
        </section>

        {/* 分类导航 */}
        <section className="category-nav">
          <div className="nav-buttons">
            <button 
              className={selectedCategory === 'all' ? 'active' : ''}
              onClick={() => setSelectedCategory('all')}
            >
              全部植物
            </button>
            {plantCategories.map(category => (
              <button
                key={category.id}
                className={selectedCategory === category.id ? 'active' : ''}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </section>

        {/* 植物展示区 */}
        <section className="plants-showcase">
          {(selectedCategory === 'all' ? plantCategories : plantCategories.filter(cat => cat.id === selectedCategory)).map(category => (
            <div key={category.id} className="category-section">
              <div className="category-header">
                <h3>{category.name}</h3>
                <p>{category.description}</p>
              </div>
              
              {/* 轮播图展示 */}
              <div className="category-carousel">
                <div className="carousel-container">
                  <div className="carousel-main">
                    <img 
                      src={category.plants[carouselIndexes[category.id] || 0]?.image} 
                      alt={category.plants[carouselIndexes[category.id] || 0]?.name}
                      className="main-image"
                    />
                    <div className="carousel-info">
                      <h4>{category.plants[carouselIndexes[category.id] || 0]?.name}</h4>
                      <p className="latin-name">{category.plants[carouselIndexes[category.id] || 0]?.latin}</p>
                      <p className="usage">{category.plants[carouselIndexes[category.id] || 0]?.usage}</p>
                    </div>
                  </div>
                  
                  {/* 缩略图导航 */}
                  <div className="carousel-nav">
                    {category.plants.map((plant, index) => (
                      <div 
                        key={index}
                        className={`nav-item ${index === (carouselIndexes[category.id] || 0) ? 'active' : ''}`}
                        onClick={() => {
                          setCarouselIndexes(prev => ({
                            ...prev,
                            [category.id]: index
                          }));
                        }}
                      >
                        <img src={plant.image} alt={plant.name} />
                        <div className="nav-overlay">
                          <span>{plant.name}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </section>

        {/* 园区特色 */}
        <section className="garden-features">
          <h2>园区特色</h2>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-image">
                <img src={plantImages[5]} alt="高山药材培育区" />
              </div>
              <div className="feature-content">
                <h3>高山药材培育区</h3>
                <p>
                  在海拔1000米以上的高山环境中，培育适应高寒气候的特色药材。
                  包括天麻、三七、党参等珍贵中药材，展现高山药材独特的生长环境和药用价值。
                </p>
              </div>
            </div>

            <div className="feature-item reverse">
              <div className="feature-content">
                <h3>濒危药用植物保护区</h3>
                <p>
                  专门设立濒危药用植物保护区，收集保护野生中药材资源。
                  通过人工繁育和栽培技术，保护濒危物种，维护生物多样性，
                  为中医药可持续发展提供种质资源保障。
                </p>
              </div>
              <div className="feature-image">
                <img src={plantImages[10]} alt="濒危药用植物保护区" />
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-image">
                <img src={plantImages[15]} alt="药用植物科普展示区" />
              </div>
              <div className="feature-content">
                <h3>药用植物科普展示区</h3>
                <p>
                  设置药用植物标本展示、中药材加工体验、药膳文化展示等科普教育设施。
                  通过互动体验，让游客了解中药材从种植到应用的全过程，
                  传承和弘扬中医药文化。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 返回按钮 */}
        <div className="back-link">
          <Link to="/" className="btn-back">返回首页</Link>
        </div>
      </div>

      {/* 植物详情弹窗 */}
      {selectedPlant && (
        <div className="plant-modal" onClick={() => setSelectedPlant(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedPlant(null)}>×</button>
            <div className="modal-image">
              <img src={selectedPlant.image} alt={selectedPlant.name} />
            </div>
            <div className="modal-info">
              <h2>{selectedPlant.name}</h2>
              <p className="latin">{selectedPlant.latin}</p>
              <div className="usage-section">
                <h3>药用功效</h3>
                <p>{selectedPlant.usage}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MedicinalGarden;
